<template>
  <!-- 无数据显示 -->
  <div class="normal-box" v-if="show">
    <img src="../assets/normal.png"  alt=""/>
    暂无数据
  </div>
</template>

<script>

export default {
  props: {
    show: {
      default: false,
    },
  },
  name: 'normal-box',
  data() {
    return {};
  }
}
</script>

<style scoped>
.normal-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  color: #666666;
  padding: 105px 0;
}

.normal-box > img {
  width: 275px;
  margin-bottom: 10px;
}
</style>
